<template>
  <transition name="fade" mode="out-in"> <component :is="activePage" /> </transition>
</template>

<script>
import welcomePage from "./WelcomePage";
import requestAccessPage from "./RequestAccessPage";
import thankyouPage from "./ThankyouPage";
import { mapState } from "vuex";

export default {
  components: {
    welcomePage,
    requestAccessPage,
    thankyouPage
  },
  computed: {
    ...mapState({
      activePage: state => state.user.activePage
    })
  }
};
</script>

<style lang="less" scoped>
#mygea {
  position: relative;
  min-height: 100vh;
  background: #e1e2e5;
}
.container {
  padding: 0;
  border-radius: 10px;
  margin: 20px auto;
  min-height: calc(100vh - 180px);
}
</style>
